// extracted by mini-css-extract-plugin
export default {"editMetaDataButton":"styles_editMetaDataButton__Gv01P"};